import { InGame } from '../../types/game-document/settings/in-game';

export const validateSettings = (
  defaultSettings: { runtime: { inGame: InGame } },
  currentSettings: { runtime: { inGame: InGame } }
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const checkRecursively = (defaultObj: any, currentObj: any): boolean => {
    for (const key in defaultObj) {
      if (currentObj[key] === null) {
        return false;
      } else if (
        typeof defaultObj[key] === 'object' &&
        !Array.isArray(defaultObj[key])
      ) {
        if (!checkRecursively(defaultObj[key], currentObj[key])) {
          return false;
        }
      }
    }
    return true;
  };

  const isValid = checkRecursively(defaultSettings, currentSettings);
  return isValid;
};
